// extracted by mini-css-extract-plugin
module.exports = {"container":"BrandedContent_container__RUUt1","videoWrapper":"BrandedContent_videoWrapper__Ysqk8","content":"BrandedContent_content__kH28J","button":"BrandedContent_button__gNBzX"};